<template>
  <div id="app">

    <router-view></router-view>

    <comp-check-query></comp-check-query>

  </div>
</template>

<script>
import CompCheckQuery from '@/components/CompCheckQuery'
export default {
  name: 'app',
  components: {
    CompCheckQuery
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%; 
  height: 100%; 
  position: fixed; 
  touch-action: manipulation;
  overflow: hidden; 
  top:0;
  left:0;
}

body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  user-select: none;
}

/* input style */
input {
  /* Remove First */
  -webkit-appearance: none;
  -moz-appearance: none;

  /* Then Style */
  font-size: 1em;
  border-radius: 0px;
  width: 100%;
  padding: 0px;
  border: 0px solid #666;
  outline: none;
  color: #000;
  background-color: transparent;
}

input::placeholder {
  opacity: 0.3;
}

/* scroll bar style */
.scrollable {
  /* -webkit-overflow-scrolling: touch;
  -ms-overflow-style: ms-autohiding-scrollbar; */
  overflow: hidden;
}
.scrollable.-x {
  overflow-x: auto;
}
.scrollable.-y {
  overflow-y: auto;
}
.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 16px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px 0 hsla(0,0%,70%,1);
  background-color: #000;
  border-radius: 0px;
}
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: hsla(200,0%,75%,1);
  border: 4px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-thumb:hover {
  background-color: hsla(200,0%,50%,1);
}
::-webkit-scrollbar-thumb:window-inactive {
  background-color: hsla(200,0%,90%,1);
}

/* global animation */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.flyIn-enter-active, .flyIn-leave-active {
  transition: transform .5s;
}
.flyIn-enter, .flyIn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(100%);
}

.flyInH-enter-active, .flyInH-leave-active {
  transition: transform .5s;
}
.flyInH-enter, .flyInH-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue